<template>
  <div class="st-loading-container" :style="stLoadingContainerStyle()">
    <div class="loading-content">
      <div class="logo-container" :style="logoContainerStyle()">
        <img src="~images/bt-loading.gif" alt="">
        <!-- <div class="inner-spinner">
          <div v-for="(color, i) in spinTheme()" :key="i" :style="spinCircleStyle(i)"></div>
        </div>
        <div class="st-logo">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="980px" height="1000px" viewBox="158 251 980 1000" enable-background="new 158 251 980 1000" xml:space="preserve">
            <rect x="161.1" y="401.9" fill="transparent" width="976.9" height="695.2"/>
            <g>
              <path :fill="logoTheme()" d="M992.269,563.607H607.983v33.704l-1.951,59.604h3.901c29.694-66.648,82.579-85.505,120.617-85.505h16.147
                v369.113c0,53.102-30.994,69.9-49.634,72.501v0.108h205.039v-0.108c-20.591-2.601-48.334-19.399-48.334-72.501V571.301h16.147
                c38.039,0,90.924,18.748,120.617,85.505h3.901l-1.951-59.604v-33.595H992.269z"/>
              <path :fill="logoTheme()" d="M674.307,784.034c0-64.698-34.787-110.105-119.967-142.4c-57.979-21.999-92.874-47.9-92.874-99.702
                c0-49.201,39.989-79.003,85.072-79.003c57.437,0,88.323,42.048,107.071,93.85h3.901l-1.3-45.299v-44.757
                c-27.743-3.901-63.181-10.404-108.371-10.404c-99.918,0-159.523,44.216-169.276,111.839v41.94
                c8.886,63.831,57.545,91.466,110.647,113.682c62.53,25.901,96.125,53.102,96.125,106.854c0,57.003-34.787,84.855-88.973,84.855
                c-63.831,0-98.618-55.703-115.416-95.15h-2.276v90.165c29.044,6.394,71.742,12.138,119.642,12.138
                C587.935,922.533,674.307,880.485,674.307,784.034z"/>
            </g>
          </svg>
        </div> -->
      </div>
      <div class="progress">
        <p>LOADING<span>{{dots}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      theme: 'darkblue', // lightblue, darkblue, lightcolor, darkcolor
      spinScheme: {
        blue: ['#0C2B57', '#7C91A6', '#00214F', '#747D86'],
        color: ['#0C2B57', '#C72A77', '#FED402', '#23A299']
      },
      dots: '...',
      dotsInterval: null
    }
  },
  mounted () {
    this.dotsInterval = setInterval(() => {
      this.dots = this.dots === '...' ? '' : (this.dots + '.')
    }, 500)
  },
  destroyed () {
    clearInterval(this.dotsInterval)
  },
  methods: {
    // spinCircleStyle (i) {
    //   return {
    //     backgroundColor: this.spinTheme()[i],
    //     animationDuration: (1 + 0.3 * i) + 's'
    //   }
    // },
    // spinTheme () {
    //   return this.theme.indexOf('blue') !== -1 ? this.spinScheme.blue : this.spinScheme.color
    // },
    // logoTheme () {
    //   return this.theme.indexOf('dark') !== -1 ? '#FFFFFF' : '#000000'
    // },
    stLoadingContainerStyle () {
      return {
        backgroundColor: '#FFFFFF'
      }
    },
    logoContainerStyle () {
      return {
        // border: this.theme.indexOf('dark') !== -1 ? '1px solid #656565' : '1px solid #D8D8D8'
      }
    }
  }
}
</script>

<style lang="scss">
$logoWidth: 90px;
$spinCircleWidth: 18px;
$spinBound: ($logoWidth - $spinCircleWidth) / 2;

.st-loading-container {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .loading-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    .progress {
      min-width: 100%;
      height: 27px;
    }

    p {
      font-family: $font-OpenSans-Regular;
      color: #333333;
      font-size: 16px;
      margin-bottom: 0;
      margin-top: 5px;
      display: inline-block;

      span {
        display: inline-block;
        width: 10px;
        text-align: left;
      }
    }
  }
}

.logo-container {
  position: relative;
  width: $logoWidth;
  height: $logoWidth;
  // border-radius: 100%;

  .inner-spinner {
    // border-radius: 100%;
    // border: 0.05em solid #d8d8d8;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: $logoWidth - $spinCircleWidth;
    height: $logoWidth - $spinCircleWidth;

    & > div {
      width: $spinCircleWidth;
      height: $spinCircleWidth;
      opacity: 0.85;
      position: absolute;
      border-radius: 100%;
      transform-origin: $spinBound $spinBound;
      animation: rota linear infinite;
    }
  }

  .st-logo {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

@keyframes rota {
  to {
    transform: rotate(360deg);
  }
}
</style>
